import { render } from "./DistributionAreas.vue?vue&type=template&id=09aadbcf&scoped=true"
import script from "./DistributionAreas.vue?vue&type=script&lang=js"
export * from "./DistributionAreas.vue?vue&type=script&lang=js"

import "./DistributionAreas.vue?vue&type=style&index=0&id=09aadbcf&lang=scss"
import "./DistributionAreas.vue?vue&type=style&index=1&id=09aadbcf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aadbcf"]])

export default __exports__